export const subHeadTop = 'メットライフ生命の代理店募集TOP'
export const subHead1 = '代理店制度の特長'
export const subHead2 = 'サポート体制'
export const names = '会社名・代理店名'
export const kanjiName = '代表者氏名 '
export const kannaName = '代表者氏名カナ'
export const birthday = '生年月日'
export const main = '主業種'
export const address = 'ご住所'
export const phoneNo = '電話番号'
export const email = 'E-mail'
export const lifeInsurance = '生命保険の販売経験'
export const metlife = 'メットライフ生命の募集人登録歴'
export const areaText = '詳しくお知りになりたい内容'
export const birth1 = '生年月日(年号）'
export const year1 = '生年月日(年）'
export const month1 = '生年月日(月）'
export const day1 = '生年月日(日）'
export const zip1 = '郵便番号（上3桁）'
export const zip2 = '郵便番号（下4桁）'
export const Prefex = '都道府県'
export const city = '市区郡'
export const town = '町・番地'
export const appartments = 'マンション・建物名'
export const sales = '販売経験'
export const recuriter = '募集人登録歴'
export const detail = '詳細内容'
